import { ISSUE_HIERARCHY_LEVEL_BASE } from '@atlassian/jira-issue-type-hierarchies';
import { EPIC_LEVEL } from '@atlassian/jira-portfolio-3-common/src/hierarchy/index.tsx';
import type { Project } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/domain/projects/types';
import type { State } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/types';
import { createSelector } from '@atlassian/jira-portfolio-3-portfolio/src/common/reselect';
import type { IssueType } from '../../state/domain/issue-types/types.tsx';
import type { Issue } from '../../state/domain/issues/types';
import { getIssueTypesByLevel } from '../hierarchy';
import { getIssuesByLevel } from '../issues';
import { getTeamManagedProjects } from '../projects';

export const getActiveCard = (state: State) => state.ui.Onboarding.activeCard;
export const isIntroOpen = (state: State) => state.ui.Onboarding.isIntroOpen;

const getLevelOneIssues = (state: State) => getIssuesByLevel(state, EPIC_LEVEL);

export const getShouldDisplayTmpCrossProjectChangeboardingPure = (
	issueTypesByLevel: Record<number, IssueType[]>,
	levelOneIssues: Issue[],
	projects: Project[],
) => {
	const issueTypesAboveEpic = issueTypesByLevel[ISSUE_HIERARCHY_LEVEL_BASE + 2] ?? [];
	if (issueTypesAboveEpic.length === 0) {
		return false;
	}
	const projectIds = new Set(projects.map((project) => project.id));

	return levelOneIssues.some(
		(issue) => projectIds.has(issue.project) && issue.parent === undefined,
	);
};

export const getShouldDisplayTmpCrossProjectChangeboarding = createSelector(
	getIssueTypesByLevel,
	getLevelOneIssues,
	getTeamManagedProjects,
	getShouldDisplayTmpCrossProjectChangeboardingPure,
);
